var _ellipse, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _g3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6,
    rx: 6,
    ry: 6,
    fill: "url(#paint0_linear_299_17443)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47533 4.94357C4.34574 5.13795 4.25136 5.40251 4.21875 5.50381L4.725 5.86816L5.11159 5.37876C5.04265 5.27406 4.97062 5.17143 4.89562 5.07099C4.83456 4.99462 4.76969 4.92138 4.70124 4.85156L4.47533 4.94357Z",
    fill: "url(#paint1_radial_299_17443)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47533 4.94357C4.34574 5.13795 4.25136 5.40251 4.21875 5.50381L4.725 5.86816L5.11159 5.37876C5.04265 5.27406 4.97062 5.17143 4.89562 5.07099C4.83456 4.99462 4.76969 4.92138 4.70124 4.85156L4.47533 4.94357Z",
    fill: "url(#paint2_radial_299_17443)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49661 4.94357C7.6262 5.13795 7.72058 5.40251 7.75319 5.50381L7.24695 5.86816L6.86035 5.37876C6.90614 5.30857 7.01434 5.15198 7.07633 5.07099C7.13853 4.99 7.23226 4.89087 7.2707 4.85156L7.49661 4.94357Z",
    fill: "url(#paint3_radial_299_17443)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49661 4.94357C7.6262 5.13795 7.72058 5.40251 7.75319 5.50381L7.24695 5.86816L6.86035 5.37876C6.90614 5.30857 7.01434 5.15198 7.07633 5.07099C7.13853 4.99 7.23226 4.89087 7.2707 4.85156L7.49661 4.94357Z",
    fill: "url(#paint4_radial_299_17443)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49661 4.94357C7.6262 5.13795 7.72058 5.40251 7.75319 5.50381L7.24695 5.86816L6.86035 5.37876C6.90614 5.30857 7.01434 5.15198 7.07633 5.07099C7.13853 4.99 7.23226 4.89087 7.2707 4.85156L7.49661 4.94357Z",
    fill: "url(#paint5_radial_299_17443)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_299_17443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.19651 4.96725L3.86732 8.24122C3.88335 8.31923 3.92583 8.38931 3.98758 8.4396C4.04932 8.4899 4.12655 8.51732 4.20619 8.51723H7.74818C7.82784 8.51725 7.90506 8.48974 7.96677 8.43937C8.02848 8.38899 8.07089 8.31884 8.08682 8.24079L8.75764 4.96704L8.5434 4.86251C8.22289 5.09533 7.55164 5.57285 7.37843 5.67738C7.2402 5.76075 7.11321 5.6249 7.08686 5.58624C6.84562 5.23204 6.47738 4.71629 6.33959 4.53509C6.19877 4.34935 6.03938 4.25778 5.97697 4.25C5.91455 4.25778 5.75516 4.34935 5.61413 4.53509C5.47655 4.71629 5.10853 5.23204 4.86707 5.58624C4.84072 5.6249 4.71373 5.76096 4.5755 5.67738C4.40229 5.57285 3.73104 5.09533 3.41054 4.86251L3.19629 4.96704L3.19651 4.96725Z",
    fill: "url(#paint6_linear_299_17443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19651 4.96725L3.86732 8.24122C3.88335 8.31923 3.92583 8.38931 3.98758 8.4396C4.04932 8.4899 4.12655 8.51732 4.20619 8.51723H7.74818C7.82784 8.51725 7.90506 8.48974 7.96677 8.43937C8.02848 8.38899 8.07089 8.31884 8.08682 8.24079L8.75764 4.96704L8.5434 4.86251C8.22289 5.09533 7.55164 5.57285 7.37843 5.67738C7.2402 5.76075 7.11321 5.6249 7.08686 5.58624C6.84562 5.23204 6.47738 4.71629 6.33959 4.53509C6.19877 4.34935 6.03938 4.25778 5.97697 4.25C5.91455 4.25778 5.75516 4.34935 5.61413 4.53509C5.47655 4.71629 5.10853 5.23204 4.86707 5.58624C4.84072 5.6249 4.71373 5.76096 4.5755 5.67738C4.40229 5.57285 3.73104 5.09533 3.41054 4.86251L3.19629 4.96704L3.19651 4.96725Z",
    fill: "url(#paint7_radial_299_17443)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20432 4.9653L3.87514 8.23926C3.89116 8.31727 3.93364 8.38735 3.99539 8.43765C4.05714 8.48794 4.13436 8.51537 4.214 8.51528H7.75599C7.83565 8.5153 7.91287 8.48779 7.97458 8.43741C8.03629 8.38704 8.0787 8.31689 8.09464 8.23883L8.76546 4.96508L8.55121 4.86055C8.2307 5.09337 7.55945 5.57089 7.38624 5.67543C7.24802 5.75879 7.12102 5.62294 7.09467 5.58428C6.85343 5.23009 6.48519 4.71434 6.3474 4.53313C6.20658 4.3474 6.0472 4.25582 5.98478 4.24805C5.92236 4.25582 5.76297 4.3474 5.62194 4.53313C5.48436 4.71434 5.11634 5.23009 4.87488 5.58428C4.84853 5.62294 4.72154 5.75901 4.58332 5.67543C4.41011 5.57089 3.73886 5.09337 3.41835 4.86055L3.2041 4.96508L3.20432 4.9653Z",
    fill: "url(#paint8_linear_299_17443)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20432 4.9653L3.87514 8.23926C3.89116 8.31727 3.93364 8.38735 3.99539 8.43765C4.05714 8.48794 4.13436 8.51537 4.214 8.51528H7.75599C7.83565 8.5153 7.91287 8.48779 7.97458 8.43741C8.03629 8.38704 8.0787 8.31689 8.09464 8.23883L8.76546 4.96508L8.55121 4.86055C8.2307 5.09337 7.55945 5.57089 7.38624 5.67543C7.24802 5.75879 7.12102 5.62294 7.09467 5.58428C6.85343 5.23009 6.48519 4.71434 6.3474 4.53313C6.20658 4.3474 6.0472 4.25582 5.98478 4.24805C5.92236 4.25582 5.76297 4.3474 5.62194 4.53313C5.48436 4.71434 5.11634 5.23009 4.87488 5.58428C4.84853 5.62294 4.72154 5.75901 4.58332 5.67543C4.41011 5.57089 3.73886 5.09337 3.41835 4.86055L3.2041 4.96508L3.20432 4.9653Z",
    fill: "url(#paint9_linear_299_17443)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20432 4.9653L3.87514 7.80731C3.89116 7.88532 3.93364 7.9554 3.99539 8.0057C4.05714 8.05599 4.13436 8.08342 4.214 8.08333H7.75599C7.83565 8.08335 7.91287 8.05584 7.97458 8.00546C8.03629 7.95509 8.0787 7.88493 8.09464 7.80688L8.76546 4.96508L8.55121 4.86055C8.2307 5.09337 7.55945 5.57089 7.38624 5.67543C7.24802 5.75879 7.12102 5.62294 7.09467 5.58428C6.85343 5.23009 6.48519 4.71434 6.3474 4.53313C6.20658 4.3474 6.0472 4.25582 5.98478 4.24805C5.92236 4.25582 5.76297 4.3474 5.62194 4.53313C5.48436 4.71434 5.11634 5.23009 4.87488 5.58428C4.84853 5.62294 4.72154 5.75901 4.58332 5.67543C4.41011 5.57089 3.73886 5.09337 3.41835 4.86055L3.2041 4.96508L3.20432 4.9653Z",
    fill: "url(#paint10_linear_299_17443)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20432 4.9653L3.87514 7.80731C3.89116 7.88532 3.93364 7.9554 3.99539 8.0057C4.05714 8.05599 4.13436 8.08342 4.214 8.08333H7.75599C7.83565 8.08335 7.91287 8.05584 7.97458 8.00546C8.03629 7.95509 8.0787 7.88493 8.09464 7.80688L8.76546 4.96508L8.55121 4.86055C8.2307 5.09337 7.55945 5.57089 7.38624 5.67543C7.24802 5.75879 7.12102 5.62294 7.09467 5.58428C6.85343 5.23009 6.48519 4.71434 6.3474 4.53313C6.20658 4.3474 6.0472 4.25582 5.98478 4.24805C5.92236 4.25582 5.76297 4.3474 5.62194 4.53313C5.48436 4.71434 5.11634 5.23009 4.87488 5.58428C4.84853 5.62294 4.72154 5.75901 4.58332 5.67543C4.41011 5.57089 3.73886 5.09337 3.41835 4.86055L3.2041 4.96508L3.20432 4.9653Z",
    fill: "url(#paint11_radial_299_17443)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20432 4.9653L3.87514 8.23926C3.89116 8.31727 3.93364 8.38735 3.99539 8.43765C4.05714 8.48794 4.13436 8.51537 4.214 8.51528H7.75599C7.83565 8.5153 7.91287 8.48779 7.97458 8.43741C8.03629 8.38704 8.0787 8.31689 8.09464 8.23883L8.76546 4.96508L8.55121 4.86055C8.2307 5.09337 7.55945 5.57089 7.38624 5.67543C7.24802 5.75879 7.12102 5.62294 7.09467 5.58428C6.85343 5.23009 6.48519 4.71434 6.3474 4.53313C6.20658 4.3474 6.0472 4.25582 5.98478 4.24805C5.92236 4.25582 5.76297 4.3474 5.62194 4.53313C5.48436 4.71434 5.11634 5.23009 4.87488 5.58428C4.84853 5.62294 4.72154 5.75901 4.58332 5.67543C4.41011 5.57089 3.73886 5.09337 3.41835 4.86055L3.2041 4.96508L3.20432 4.9653Z",
    fill: "#565656"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59184 4.91349C3.59184 4.99313 3.5602 5.06952 3.50388 5.12584C3.44756 5.18216 3.37117 5.2138 3.29152 5.2138C3.21188 5.2138 3.13549 5.18216 3.07917 5.12584C3.02285 5.06952 2.99121 4.99313 2.99121 4.91349C2.99121 4.83387 3.02284 4.75751 3.07914 4.70121C3.13544 4.64491 3.2118 4.61328 3.29142 4.61328C3.37104 4.61328 3.44739 4.64491 3.50369 4.70121C3.55999 4.75751 3.59162 4.83387 3.59162 4.91349H3.59184Z",
    fill: "url(#paint12_radial_299_17443)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59184 4.91349C3.59184 4.99313 3.5602 5.06952 3.50388 5.12584C3.44756 5.18216 3.37117 5.2138 3.29152 5.2138C3.21188 5.2138 3.13549 5.18216 3.07917 5.12584C3.02285 5.06952 2.99121 4.99313 2.99121 4.91349C2.99121 4.83387 3.02284 4.75751 3.07914 4.70121C3.13544 4.64491 3.2118 4.61328 3.29142 4.61328C3.37104 4.61328 3.44739 4.64491 3.50369 4.70121C3.55999 4.75751 3.59162 4.83387 3.59162 4.91349H3.59184Z",
    fill: "url(#paint13_radial_299_17443)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59184 4.91349C3.59184 4.99313 3.5602 5.06952 3.50388 5.12584C3.44756 5.18216 3.37117 5.2138 3.29152 5.2138C3.21188 5.2138 3.13549 5.18216 3.07917 5.12584C3.02285 5.06952 2.99121 4.99313 2.99121 4.91349C2.99121 4.83387 3.02284 4.75751 3.07914 4.70121C3.13544 4.64491 3.2118 4.61328 3.29142 4.61328C3.37104 4.61328 3.44739 4.64491 3.50369 4.70121C3.55999 4.75751 3.59162 4.83387 3.59162 4.91349H3.59184Z",
    fill: "url(#paint14_radial_299_17443)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59184 4.91349C3.59184 4.99313 3.5602 5.06952 3.50388 5.12584C3.44756 5.18216 3.37117 5.2138 3.29152 5.2138C3.21188 5.2138 3.13549 5.18216 3.07917 5.12584C3.02285 5.06952 2.99121 4.99313 2.99121 4.91349C2.99121 4.83387 3.02284 4.75751 3.07914 4.70121C3.13544 4.64491 3.2118 4.61328 3.29142 4.61328C3.37104 4.61328 3.44739 4.64491 3.50369 4.70121C3.55999 4.75751 3.59162 4.83387 3.59162 4.91349H3.59184Z",
    fill: "url(#paint15_linear_299_17443)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74687 4.9694C4.80421 4.93581 4.84878 4.88414 4.8736 4.8225C4.89843 4.76085 4.90209 4.69271 4.88403 4.62876C4.86597 4.56481 4.82719 4.50866 4.77379 4.46911C4.72038 4.42956 4.65537 4.40885 4.58893 4.41022C4.52248 4.41159 4.45838 4.43497 4.40665 4.47669C4.35493 4.51842 4.31851 4.57612 4.3031 4.64076C4.28769 4.70541 4.29417 4.77334 4.32152 4.8339C4.34887 4.89447 4.39554 4.94425 4.45422 4.97544C4.48313 4.96431 4.51487 4.96279 4.54471 4.97112C4.59093 4.98451 4.66695 5.00136 4.74708 4.9694H4.74687Z",
    fill: "url(#paint16_radial_299_17443)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74687 4.9694C4.80421 4.93581 4.84878 4.88414 4.8736 4.8225C4.89843 4.76085 4.90209 4.69271 4.88403 4.62876C4.86597 4.56481 4.82719 4.50866 4.77379 4.46911C4.72038 4.42956 4.65537 4.40885 4.58893 4.41022C4.52248 4.41159 4.45838 4.43497 4.40665 4.47669C4.35493 4.51842 4.31851 4.57612 4.3031 4.64076C4.28769 4.70541 4.29417 4.77334 4.32152 4.8339C4.34887 4.89447 4.39554 4.94425 4.45422 4.97544C4.48313 4.96431 4.51487 4.96279 4.54471 4.97112C4.59093 4.98451 4.66695 5.00136 4.74708 4.9694H4.74687Z",
    fill: "url(#paint17_radial_299_17443)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74687 4.9694C4.80421 4.93581 4.84878 4.88414 4.8736 4.8225C4.89843 4.76085 4.90209 4.69271 4.88403 4.62876C4.86597 4.56481 4.82719 4.50866 4.77379 4.46911C4.72038 4.42956 4.65537 4.40885 4.58893 4.41022C4.52248 4.41159 4.45838 4.43497 4.40665 4.47669C4.35493 4.51842 4.31851 4.57612 4.3031 4.64076C4.28769 4.70541 4.29417 4.77334 4.32152 4.8339C4.34887 4.89447 4.39554 4.94425 4.45422 4.97544C4.48313 4.96431 4.51487 4.96279 4.54471 4.97112C4.59093 4.98451 4.66695 5.00136 4.74708 4.9694H4.74687Z",
    fill: "url(#paint18_radial_299_17443)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74687 4.9694C4.80421 4.93581 4.84878 4.88414 4.8736 4.8225C4.89843 4.76085 4.90209 4.69271 4.88403 4.62876C4.86597 4.56481 4.82719 4.50866 4.77379 4.46911C4.72038 4.42956 4.65537 4.40885 4.58893 4.41022C4.52248 4.41159 4.45838 4.43497 4.40665 4.47669C4.35493 4.51842 4.31851 4.57612 4.3031 4.64076C4.28769 4.70541 4.29417 4.77334 4.32152 4.8339C4.34887 4.89447 4.39554 4.94425 4.45422 4.97544C4.48313 4.96431 4.51487 4.96279 4.54471 4.97112C4.59093 4.98451 4.66695 5.00136 4.74708 4.9694H4.74687Z",
    fill: "url(#paint19_linear_299_17443)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_299_17443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22562 4.9694C7.16827 4.93581 7.1237 4.88414 7.09888 4.8225C7.07405 4.76085 7.07039 4.69271 7.08845 4.62876C7.10652 4.56481 7.14529 4.50866 7.19869 4.46911C7.2521 4.42956 7.31712 4.40885 7.38356 4.41022C7.45 4.41159 7.5141 4.43497 7.56583 4.47669C7.61755 4.51842 7.65397 4.57612 7.66938 4.64076C7.68479 4.70541 7.67831 4.77334 7.65096 4.8339C7.62361 4.89447 7.57694 4.94425 7.51826 4.97544C7.48935 4.96431 7.45761 4.96279 7.42777 4.97112C7.38155 4.98451 7.30553 5.00136 7.2254 4.9694H7.22562Z",
    fill: "url(#paint20_linear_299_17443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22562 4.9694C7.16827 4.93581 7.1237 4.88414 7.09888 4.8225C7.07405 4.76085 7.07039 4.69271 7.08845 4.62876C7.10652 4.56481 7.14529 4.50866 7.19869 4.46911C7.2521 4.42956 7.31712 4.40885 7.38356 4.41022C7.45 4.41159 7.5141 4.43497 7.56583 4.47669C7.61755 4.51842 7.65397 4.57612 7.66938 4.64076C7.68479 4.70541 7.67831 4.77334 7.65096 4.8339C7.62361 4.89447 7.57694 4.94425 7.51826 4.97544C7.48935 4.96431 7.45761 4.96279 7.42777 4.97112C7.38155 4.98451 7.30553 5.00136 7.2254 4.9694H7.22562Z",
    fill: "url(#paint21_linear_299_17443)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_299_17443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03711 4.35211C6.07447 4.34779 6.1695 4.36701 6.25308 4.4804C6.33688 4.59379 6.84615 5.31946 7.0902 5.66826C7.1375 5.74126 7.27724 5.85659 7.45801 5.73241C7.639 5.60822 8.22062 5.18707 8.44005 5.04086",
    stroke: "url(#paint22_linear_299_17443)",
    strokeWidth: 0.0776053
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03711 4.35211C6.07447 4.34779 6.1695 4.36701 6.25308 4.4804C6.33688 4.59379 6.84615 5.31946 7.0902 5.66826C7.1375 5.74126 7.27724 5.85659 7.45801 5.73241C7.639 5.60822 8.22062 5.18707 8.44005 5.04086",
    stroke: "url(#paint23_radial_299_17443)",
    strokeWidth: 0.0776053
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97979 4.37755C6.19461 4.37755 6.36876 4.2034 6.36876 3.98858C6.36876 3.77376 6.19461 3.59961 5.97979 3.59961C5.76497 3.59961 5.59082 3.77376 5.59082 3.98858C5.59082 4.2034 5.76497 4.37755 5.97979 4.37755Z",
    fill: "url(#paint24_radial_299_17443)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97979 4.37755C6.19461 4.37755 6.36876 4.2034 6.36876 3.98858C6.36876 3.77376 6.19461 3.59961 5.97979 3.59961C5.76497 3.59961 5.59082 3.77376 5.59082 3.98858C5.59082 4.2034 5.76497 4.37755 5.97979 4.37755Z",
    fill: "url(#paint25_radial_299_17443)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97979 4.37755C6.19461 4.37755 6.36876 4.2034 6.36876 3.98858C6.36876 3.77376 6.19461 3.59961 5.97979 3.59961C5.76497 3.59961 5.59082 3.77376 5.59082 3.98858C5.59082 4.2034 5.76497 4.37755 5.97979 4.37755Z",
    fill: "url(#paint26_radial_299_17443)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97979 4.37755C6.19461 4.37755 6.36876 4.2034 6.36876 3.98858C6.36876 3.77376 6.19461 3.59961 5.97979 3.59961C5.76497 3.59961 5.59082 3.77376 5.59082 3.98858C5.59082 4.2034 5.76497 4.37755 5.97979 4.37755Z",
    fill: "url(#paint27_linear_299_17443)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99516 4.91349C8.99516 4.99313 8.96352 5.06952 8.9072 5.12584C8.85088 5.18216 8.77449 5.2138 8.69484 5.2138C8.6152 5.2138 8.53881 5.18216 8.48249 5.12584C8.42617 5.06952 8.39453 4.99313 8.39453 4.91349C8.39453 4.83387 8.42616 4.75751 8.48246 4.70121C8.53876 4.64491 8.61512 4.61328 8.69474 4.61328C8.77436 4.61328 8.85071 4.64491 8.90701 4.70121C8.96331 4.75751 8.99494 4.83387 8.99494 4.91349H8.99516Z",
    fill: "url(#paint28_radial_299_17443)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99516 4.91349C8.99516 4.99313 8.96352 5.06952 8.9072 5.12584C8.85088 5.18216 8.77449 5.2138 8.69484 5.2138C8.6152 5.2138 8.53881 5.18216 8.48249 5.12584C8.42617 5.06952 8.39453 4.99313 8.39453 4.91349C8.39453 4.83387 8.42616 4.75751 8.48246 4.70121C8.53876 4.64491 8.61512 4.61328 8.69474 4.61328C8.77436 4.61328 8.85071 4.64491 8.90701 4.70121C8.96331 4.75751 8.99494 4.83387 8.99494 4.91349H8.99516Z",
    fill: "url(#paint29_radial_299_17443)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99516 4.91349C8.99516 4.99313 8.96352 5.06952 8.9072 5.12584C8.85088 5.18216 8.77449 5.2138 8.69484 5.2138C8.6152 5.2138 8.53881 5.18216 8.48249 5.12584C8.42617 5.06952 8.39453 4.99313 8.39453 4.91349C8.39453 4.83387 8.42616 4.75751 8.48246 4.70121C8.53876 4.64491 8.61512 4.61328 8.69474 4.61328C8.77436 4.61328 8.85071 4.64491 8.90701 4.70121C8.96331 4.75751 8.99494 4.83387 8.99494 4.91349H8.99516Z",
    fill: "url(#paint30_radial_299_17443)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99516 4.91349C8.99516 4.99313 8.96352 5.06952 8.9072 5.12584C8.85088 5.18216 8.77449 5.2138 8.69484 5.2138C8.6152 5.2138 8.53881 5.18216 8.48249 5.12584C8.42617 5.06952 8.39453 4.99313 8.39453 4.91349C8.39453 4.83387 8.42616 4.75751 8.48246 4.70121C8.53876 4.64491 8.61512 4.61328 8.69474 4.61328C8.77436 4.61328 8.85071 4.64491 8.90701 4.70121C8.96331 4.75751 8.99494 4.83387 8.99494 4.91349H8.99516Z",
    fill: "url(#paint31_linear_299_17443)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_299_17443",
    x: 2.98934,
    y: 4.19826,
    width: 5.97542,
    height: 4.31932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.206948,
    dy: -0.0517369
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.129342
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.580392 0 0 0 0 0.262745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_299_17443"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.206948,
    dy: -0.0517369
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.129342
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.686275 0 0 0 0 0.301961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_299_17443",
    result: "effect2_innerShadow_299_17443"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_299_17443",
    x: 7.07715,
    y: 4.41016,
    width: 0.600586,
    height: 0.578125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0646711
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.619608 0 0 0 0 0.321569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_299_17443"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_299_17443",
    x: 5.95462,
    y: 4.23489,
    width: 2.5849,
    height: 1.66888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0388027,
    result: "effect1_foregroundBlur_299_17443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_17443",
    x1: 6,
    y1: -2.16,
    x2: 6,
    y2: 13.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.39931 5.26256) rotate(15.9454) scale(0.687891 1.71695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC567"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.80426 5.41094) rotate(-156.753) scale(0.52154 1.56856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#D89F3A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#DAA139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.68735 5.68077) rotate(-125.455) scale(0.546853 0.56085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#BF812A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.26552 5.41418) rotate(-23.0909) scale(0.47324 1.23286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#E9BB61",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#E9BB61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.54579 5.54911) rotate(-142.922) scale(0.744444 1.25591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#C18739",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#C18739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_299_17443",
    x1: 7.5335,
    y1: 6.78727,
    x2: 3.71808,
    y2: 7.67709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FCAD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB7547"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.14201 9.22326) rotate(-69.4212) scale(2.37629 4.62502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67B4E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_299_17443",
    x1: 3.66996,
    y1: 7.584,
    x2: 4.2572,
    y2: 7.46262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07648",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_299_17443",
    x1: 5.98478,
    y1: 3.47994,
    x2: 5.98478,
    y2: 9.19804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_299_17443",
    x1: 6.29557,
    y1: 8.57619,
    x2: 6.29557,
    y2: 8.31961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FF6F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.5903 5.01929) rotate(113.385) scale(0.544138 0.451047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#DD9049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8BF60",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.53434 4.7083) rotate(135.198) scale(0.642065 0.667982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#E7C04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9972A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.22399 5.25303) rotate(-71.331) scale(0.35843 0.388262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#DF8089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF8089",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.55836 4.72213) rotate(141.017) scale(0.303889 0.157042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_299_17443",
    x1: 3.29152,
    y1: 4.50519,
    x2: 3.29152,
    y2: 5.30988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.83816 4.50129) rotate(136.302) scale(0.630122 0.654894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#E7C04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9972A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.86176 4.51477) rotate(142.093) scale(0.299394 0.153372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.59525 5.02425) rotate(-76.7988) scale(0.280764 0.374457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A122",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_299_17443",
    x1: 4.59513,
    y1: 4.3062,
    x2: 4.59513,
    y2: 5.08012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_299_17443",
    x1: 7.37735,
    y1: 4.3062,
    x2: 7.37735,
    y2: 5.08012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_299_17443",
    x1: 7.37735,
    y1: 4.3062,
    x2: 7.37735,
    y2: 5.08012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_299_17443",
    x1: 6.03733,
    y1: 4.30848,
    x2: 7.40747,
    y2: 6.03628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.40747 5.86761) rotate(-34.6679) scale(1.40324 0.375845)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#FFD175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD175",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.29137 3.77431) rotate(125.606) scale(0.741919 0.629906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#F3D154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC9848"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.90636 4.37755) rotate(-79.3129) scale(0.395789 0.470481)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E78F5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.14264 4.1186) rotate(-146.725) scale(0.774986 0.92692)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#E9C251",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B49858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_299_17443",
    x1: 5.97979,
    y1: 3.45958,
    x2: 5.97979,
    y2: 4.50202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.93775 4.70852) rotate(135.198) scale(0.642065 0.667982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#F8CB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA34B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.62735 5.253) rotate(-71.3304) scale(0.358429 0.484488)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F1907C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1907C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_299_17443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.9619 4.72235) rotate(141.017) scale(0.303889 0.157042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_299_17443",
    x1: 8.69484,
    y1: 4.50519,
    x2: 8.69484,
    y2: 5.30988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.0477d185f920c1cba21b1a843a75611b.svg";
export { ForwardRef as ReactComponent };